var _path, _line, _line2, _path2, _path3, _polyline, _line3, _line4, _line5, _line6, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRespirationRate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    d: "M21.9,6.5V5.3h-3.8v8.8c0,0,1,4.7-4.2,5.1c-0.6-0.1-1.3-0.4-0.9,0.8c0.4,1.2,3.8,5.9-2.8,10.5"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    x1: 13.6,
    y1: 21.3,
    x2: 9.8,
    y2: 21.3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    x1: 14.2,
    y1: 25.3,
    x2: 8.2,
    y2: 26
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    d: "M29.8,30.5c0,0-6.5-3.2-3-10.3c0.4-0.8,1.2-1.7-0.2-1.2c-0.7,0.2-5.3,0.9-4.7-6.3c0.1,0.1,3.5-2.8,9.4,1.6c0.7,0.8,1.9,1.3,3.6,8.5c0.5,1.7,2,6.4,2,6.4s1.8,3.3-1.7,5.3c-0.5,0.2-1.2,0.4-2.6,0.2c-0.5-0.2-2-0.7-3.7-0.8c-1.2-0.2-6.2-1-7-5.6c0-2.9,0-6.2,0-6.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    d: "M18,22.4v5.2c0,0,1.1,4-5.4,6.1c-0.8,0.3-2.5,0.2-4.4,0.8C7,34.7,5,35.3,3.1,32.9c-0.2-0.4-1.3-1.6,0.4-5.3c1-2.5,3.2-9.7,3.2-9.7s1.1-5.8,8.6-6c0.7,0,1.3-0.3,2.7,0.8"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "currentColor",
    points: "14.2,23.4 20,20.9 25.8,23.4"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    x1: 20,
    y1: 20.9,
    x2: 20,
    y2: 16
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    x1: 18.2,
    y1: 15.6,
    x2: 21.9,
    y2: 15.6
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    x1: 26.3,
    y1: 21.5,
    x2: 30.1,
    y2: 21.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    x1: 25.8,
    y1: 25.1,
    x2: 31.9,
    y2: 26
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "currentColor",
    cx: 21.8,
    cy: 9.2,
    r: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRespirationRate);
export default __webpack_public_path__ + "static/media/RespirationRate.ba2127eccf325a82020173c7899993ff.svg";
export { ForwardRef as ReactComponent };